import { MergeTagData, MergeTagNode } from './MergeTagNode';

export function $createMergeTagNode(tag: MergeTagData): MergeTagNode {
  return new MergeTagNode(tag);
}
